import { getMetaValue } from "@/utils/meta.utils"

export const nativeSubmit = (method: "post" | "delete", url: string) => {
  const form = document.createElement("form")
  form.method = "post"
  form.action = url
  const token = document.createElement("input")
  token.type = "hidden"
  token.name = "authenticity_token"
  token.value = getMetaValue("csrf-token")
  form.appendChild(token)
  if (method === "delete") {
    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "DELETE"
    form.appendChild(methodInput)
  }
  document.body.appendChild(form)
  form.submit()
}
